import React, { FC, useContext } from "react";
import { isMobile } from "react-device-detect";
import { Rodape, SectionTab } from "../../Components/Shell";
import FormContato from "../../Components/Shell/FormContato";
import { withDepoimentosContext } from "../../Context/Depoimentos";
import { DepoimentosContext } from "../../Context/Depoimentos/Depoimentos.Provider";
import { withLeadContext } from "../../Context/Lead";
import { LeadContext } from "../../Context/Lead/Lead.Provider";
import { withPlanoContext } from "../../Context/Plano";
import { PlanoContext } from "../../Context/Plano/Plano.Provider";
import { withVeterinarioContext } from "../../Context/Veterinario";
import { VeterinarioContext } from "../../Context/Veterinario/Veterinario.Provider";
import {
  About,
  Time,
  Diferenciais,
  PerguntasFrequentes,
  Depoimentos,
} from "./Components";
import BannerPrincipal from "./Components/BannerPrincipal";
import Planos from "./Components/Planos";
import styles from "./Home.module.scss";

const Home: FC = (props) => {
  const leadContext = useContext(LeadContext);
  const planosContext = useContext(PlanoContext);
  const vetContext = useContext(VeterinarioContext);
  const depoimentosContext = useContext(DepoimentosContext);

  return (
    <div className={styles["Home"]}>
      <div className={`${styles["Content"]}`}>
        <SectionTab identifier="principal">
          <BannerPrincipal />
        </SectionTab>
        <SectionTab identifier="planos">
          <Planos planosContext={planosContext} />
        </SectionTab>
        <SectionTab identifier="about">
          <About />
        </SectionTab>
        <SectionTab identifier="time">
          <Time vetContext={vetContext} />
        </SectionTab>
        <SectionTab identifier="formContato">
          <FormContato leadContext={leadContext} planoContext={planosContext} />
        </SectionTab>
        <SectionTab identifier="depoimentos">
          <Depoimentos depoimentosContext={depoimentosContext} />
        </SectionTab>
        <SectionTab identifier="perguntasfrequentes">
          <PerguntasFrequentes />
        </SectionTab>
        <SectionTab identifier="facaParteTimeQueroVet">
          {/* <FormVet /> */}
        </SectionTab>
        <Rodape />
      </div>
    </div>
  );
};

export default withLeadContext(
  withPlanoContext(withVeterinarioContext(withDepoimentosContext(Home)))
);
